// Module
var code = `<div class="jumbotron small m-t-10 m-b-10"> <h1>TE Auth</h1> <loader loading="authenticateTokenController.loading" message="Authenticating..."> </loader> </div> `;
// Exports
module.exports = code;